import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const MatrixPopup = ({ showManually = false, onClose = null }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (showManually) {
      // Show immediately when triggered manually
      console.log("Matrix popup triggered manually");
      setIsVisible(true);
    } else {
      // Auto show after 2 seconds on page load
      console.log("MatrixPopup component mounted - popup should appear in 2 seconds");
      
      const timer = setTimeout(() => {
        console.log("Showing Matrix popup automatically");
        setIsVisible(true);
      }, 2000);

      return () => {
        console.log("MatrixPopup component unmounting");
        clearTimeout(timer);
      };
    }
  }, [showManually]);

  const handleClose = () => {
    console.log("Matrix popup closed");
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };

  const handleContactClick = () => {
    console.log("Matrix popup - Saber Mais clicked");
    // Scroll to contact section
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    handleClose();
  };

  console.log("MatrixPopup render - isVisible:", isVisible, "showManually:", showManually);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div 
        className="bg-white rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-y-auto relative shadow-2xl transform animate-in zoom-in-95 duration-500"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 z-10 bg-white/90 text-sage-dark hover:text-gold-warm transition-colors duration-200 rounded-full p-1.5 shadow-lg"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Image container */}
        <div className="relative">
          <img 
            src="https://customer-assets.emergentagent.com/job_beauty-rejuvenate/artifacts/lnad6lx1_Feed%20Matrix_3caixas.png"
            alt="MATRIX Chronology - Protocolo 2 meses"
            className="w-full h-auto object-contain max-h-[50vh]"
            onLoad={() => console.log("Matrix popup image loaded successfully")}
            onError={() => console.error("Matrix popup image failed to load")}
          />
        </div>
        
        {/* Content section */}
        <div className="p-6">
          <div className="text-center">
            <h3 className="text-2xl font-playfair font-bold text-sage-dark mb-3">
              MATRIX Chronology
            </h3>
            <p className="text-sage-medium mb-6 leading-relaxed">
              Protocolo completo de rejuvenescimento com colágeno, ácido hialurônico e vitaminas essenciais. 
              Transforme a sua pele em apenas 2 meses com resultados visíveis.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={handleContactClick}
                className="bg-gold-warm text-white px-8 py-3 rounded-full hover:bg-gold-deep transition-all duration-300 transform hover:scale-105 font-semibold"
              >
                Saber Mais
              </button>
              <button
                onClick={handleClose}
                className="bg-sage-soft text-sage-dark px-8 py-3 rounded-full hover:bg-sage-medium transition-colors duration-300 font-semibold"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatrixPopup;